"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const BSRCaution = createSVGIcon(
  <path
    d="M12 8.5v6m0 2.75h.005m-.304-15.43L1.76 20.755a.338.338 0 0 0 .298.494h19.884c.253 0 .416-.27.298-.494L12.3 1.819a.337.337 0 0 0-.598 0Z"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
  />,
  "BSRCaution",
  {
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
